import { render, staticRenderFns } from "./CreateSteadReceive.vue?vue&type=template&id=c1cdf940&scoped=true&"
import script from "./CreateSteadReceive.vue?vue&type=script&lang=js&"
export * from "./CreateSteadReceive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1cdf940",
  null
  
)

export default component.exports